<app-loading-state *ngIf="spinner && !ready" [message]="spinnerMessage"></app-loading-state>
<convfact-financiacion-privada-form *ngIf="ready" [financiacionPrivada]="financiacionPrivada" (onSave)="saveData($event)">
</convfact-financiacion-privada-form>
<div class="fin-saving-overlay" *ngIf="spinner && ready">
  <app-loading-state [message]="spinnerMessage"></app-loading-state>
</div>
